module.exports = __webpack_public_path__ + "static/media/amazon-pay.a04568ab.svg";